/* eslint-disable max-len */
import { SvgIcon } from '@mui/material';
import { CustomSvgIcon } from '@tassat/ui-definitions';
import * as React from 'react';

export default function Lock(props: CustomSvgIcon) {
    const {
        id,
        className,
        iconColor,
        onClick
    } = props;

    return (
        <SvgIcon
            className={className || ''}
            data-testid='locked-symbol-value'
            id={id || ''}
            onClick={onClick}
            viewBox='0 0 25 32.5'
        >
            <svg xmlns='http://www.w3.org/2000/svg'>
                <g>
                    <title>lock</title>
                    <g
                        data-name='Layer 2'
                        id='Layer_2'
                    >
                        <g
                            data-name='Layer 1'
                            fill={iconColor || '#000'}
                            id='Layer_1-2'
                        >
                            <path d='M23.33,28.33a2.5,2.5,0,0,1-2.5,2.5H4.17a2.5,2.5,0,0,1-2.5-2.5V17.5A2.5,2.5,0,0,1,4.17,15H20.83a2.5,2.5,0,0,1,2.5,2.5Zm-17.5-20a6.67,6.67,0,0,1,13.34,0v5H5.83Zm15,5v-5a8.33,8.33,0,1,0-16.66,0v5A4.17,4.17,0,0,0,0,17.5V28.33A4.17,4.17,0,0,0,4.17,32.5H20.83A4.17,4.17,0,0,0,25,28.33V17.5A4.17,4.17,0,0,0,20.83,13.33Z' />
                        </g>
                    </g>
                </g>
            </svg>
        </SvgIcon>
    );
}